

























































import { Vue, Component, Prop } from 'vue-property-decorator';

import {
  IWidgetSettingsFormData,
  WidgetNameIcon
} from '@/models/Widget/settings';
import { WidgetThemesDictionary } from '@/models/Widget/themes';

import CouponIcon from '@/components/icons/WidgetCoupon.vue';
import TrophyIcon from '@/components/icons/WidgetTrophy.vue';
import WalletIcon from '@/components/icons/WidgetWallet.vue';
import GiftIcon from '@/components/icons/WidgetGift.vue';
import CoinIcon from '@/components/icons/WidgetCoin.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import WidgetArrowClose from '@/components/icons/WidgetArrowClose.vue';

@Component({
  components: {
    TrophyIcon,
    WalletIcon,
    GiftIcon,
    CoinIcon,
    CouponIcon,
    Typography,
    WidgetArrowClose
  }
})
export default class WidgetIcon extends Vue {
  @Prop() widgetConfigProps!: IWidgetSettingsFormData;
  @Prop() positionStyle?: any;
  @Prop({ default: 'coupon' }) nameIcon?: WidgetNameIcon;
  @Prop({ default: false }) preview?: boolean;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showIconAndText() {
    return this.widgetConfigProps.previewState !== 'popover' || !this.preview;
  }

  get themeSettings() {
    return WidgetThemesDictionary[this.widgetConfigProps.widgetStyle.color];
  }

  get widgetConfigPropsHasValues() {
    const hasValues = Object.keys(this.widgetConfigProps || {}).length;

    return !!hasValues;
  }

  get popoverTheme() {
    if (!this.widgetConfigPropsHasValues) return '';

    return this.widgetConfigProps.widgetStyle.color;
  }

  get themeGradientAsBackgroundStyle() {
    return {
      backgroundImage: this.themeSettings.primaryGradient
    };
  }

  get themeAsTextColorStyle() {
    return {
      color: this.themeSettings.primaryGradientTextColor || '#FFF'
    };
  }

  get textActived() {
    return (
      this.preview &&
      this.widgetConfigProps.widgetStyle.text &&
      this.widgetConfigProps.widgetStyle.launcher === 'both'
    );
  }
}
